var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPantherBetScratch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 171,
    viewBox: "0 0 167 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3074_7069)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.375 -43.8672C101.375 -43.8672 79.4601 -11.3852 61.343 28.8915C43.2265 69.1681 19.5827 114.326 19.5827 114.326L13.4415 122.463L-0.4375 149.02L14.0559 160.298L112.622 -32.9469L101.375 -43.8672Z",
    fill: "url(#paint0_radial_3074_7069)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.855 4.22656C152.855 4.22656 131.842 35.3719 114.471 73.9907C97.0999 112.609 74.4289 155.909 74.4289 155.909L61.1874 182.773L53.1641 195.837L65.2076 208.462L163.639 14.6974L152.855 4.22656Z",
    fill: "url(#paint1_radial_3074_7069)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.483 44.75C170.483 44.75 151.59 72.751 135.974 107.471C120.356 142.19 99.9745 181.119 99.9745 181.119L94.6808 188.133L83.8281 211.75L95.2099 220.749L180.178 54.1643L170.483 44.75Z",
    fill: "url(#paint2_radial_3074_7069)",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.809 -59.1953C145.809 -59.1953 89.7741 42.484 72.5274 80.8248C55.2815 119.166 32.774 162.154 32.774 162.154L26.9281 169.9L14.582 196.218L27.5131 205.918L156.515 -48.8001L145.809 -59.1953Z",
    fill: "url(#paint3_radial_3074_7069)",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.385 60.8125L151.043 83.9868L150.605 88.1113L145.495 95.9672L142.576 102.252L143.014 108.34L140.97 110.893L140.533 115.999L137.175 119.731L139.219 126.408L134.694 128.175L131.628 132.103L132.066 139.37L128.563 141.334L128.855 146.637H125.498L118.637 158.421L116.448 159.206L114.404 161.17L113.82 165.491L108.858 167.455L101.121 178.846L106.814 164.706L108.858 161.76L109.15 159.6L110.901 159.01C110.901 159.01 110.318 155.868 110.463 155.279C110.609 154.69 112.361 151.155 112.361 151.155L111.34 148.405L114.551 141.727L116.302 140.156L115.719 137.21L117.762 136.032L118.346 129.551L119.368 125.82L121.265 125.231L122.931 118.328L128.093 112.804L133.09 100.484L136.593 97.342L136.739 94.0032L139.658 90.0753C139.658 90.0753 141.118 84.5759 141.264 85.165C141.41 85.7541 143.307 86.7365 143.307 86.7365L143.6 83.3977L147.019 79.7506L148.797 76.4061L150.328 75.1918L152.013 72.0777L160.385 60.8125Z",
    fill: "url(#paint4_linear_3074_7069)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.347 14.4375L121.928 50.2094L120.737 53.6281L118.553 55.7325L118.752 58.0998L115.576 62.3086L114.186 67.5688L110.017 69.6732L109.024 77.5644L104.657 79.4052L100.487 89.9264V94.9238L98.304 98.0804L95.5246 99.1319L90.3628 107.023L89.5691 116.229L84.6056 120.701L80.0399 129.906V133.589L77.0622 138.06L77.4587 140.165L75.6724 142.795L74.0838 148.844L72.6941 154.894L70.7089 154.368L70.5107 159.629L68.1284 164.1L67.7312 167.52L65.1506 171.465L66.1432 172.78L61.1797 182.775L69.7164 171.991L71.5032 170.939V166.205L74.8781 164.363L77.6576 160.418L78.0548 156.998L81.0325 157.261L83.4148 150.422L87.1868 145.162L88.5759 140.69L91.5543 138.323L92.1497 133.589L96.12 130.433L96.3189 125.172L99.6938 120.964L103.664 117.019L102.87 107.812L107.436 104.393L108.23 97.0282L111.804 93.0823L114.186 86.507L118.156 85.4548L117.362 79.668L120.936 77.5644L120.538 73.8813L123.119 72.5662L122.325 66.7795L126.097 63.3608L127.486 57.8369L130.861 54.6803L129.869 50.998L134.237 44.159L146.347 14.4375Z",
    fill: "#2C3A44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.438 86.0625L113.081 86.1561L112.901 86.6502L110.598 92.9778L111.135 92.3865L113.438 86.0625Z",
    fill: "url(#paint5_linear_3074_7069)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.434 107.821L101.497 108.55L102.244 117.07L102.796 116.52L102.043 107.936L101.996 107.398L101.918 107.457L101.434 107.821Z",
    fill: "url(#paint6_linear_3074_7069)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.164 73.8364L119.247 74.6387L119.519 77.2667L120.094 76.9332L119.792 74.0244L119.743 73.5469L119.727 73.5548L119.164 73.8364Z",
    fill: "url(#paint7_linear_3074_7069)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M121.62 66.9466L121.553 66.4453L121.376 66.6016L120.992 66.9415L121.074 67.5602L121.693 72.222L122.281 71.9274L121.62 66.9466Z",
    fill: "url(#paint8_linear_3074_7069)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M107.396 96.8658L107.441 96.4531L107.146 96.7772L106.897 97.0516L106.851 97.4794L106.137 104.076L106.659 103.684L107.396 96.8658Z",
    fill: "url(#paint9_linear_3074_7069)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.914 79.6417L116.025 80.4671L116.598 84.7529L117.205 84.5938L116.571 79.8535L116.497 79.3047L116.487 79.3104L115.914 79.6417Z",
    fill: "url(#paint10_linear_3074_7069)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.435 57.9226L126.366 58.1869L125.051 63.2289L125.552 62.7853L126.912 57.5733L126.941 57.4609L126.597 57.7742L126.435 57.9226Z",
    fill: "url(#paint11_linear_3074_7069)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1618 110.087L66.2103 109.983L66.2799 109.894L73.7807 100.246L75.5584 91.7426L75.6234 91.4344L75.8092 91.2205L81.3793 84.8108L82.3764 74.785L82.4106 74.4393L82.5871 74.1807L87.6826 66.7109L87.6314 66.7405L87.4719 66.8341L87.3511 67.0105L82.0416 74.7944L81.865 75.0529L81.8309 75.3986L80.8337 85.4251L75.2636 91.8341L75.0779 92.0479L75.0129 92.3562L73.2352 100.859L65.7344 110.507L65.6648 110.596L65.6162 110.701L61.3164 119.936L61.6 119.885L66.1618 110.087Z",
    fill: "url(#paint12_linear_3074_7069)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1092 64.9977L90.3554 59.7028L90.3738 59.3125L90.1808 59.476L89.8355 59.7684L89.8099 60.3164L89.5781 65.3088L90.1092 64.9977Z",
    fill: "url(#paint13_linear_3074_7069)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4884 140.686L87.407 140.957L86.096 145.309L82.4553 150.5L82.385 150.6L82.3476 150.709L80.3828 156.516L80.713 156.541L82.8931 150.096L82.9306 149.986L83.0008 149.886L86.6422 144.694L87.9525 140.343L87.9663 140.297L87.6886 140.523L87.4884 140.686Z",
    fill: "url(#paint14_linear_3074_7069)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.39 161.411L113.359 161.669L112.926 165.253L113.423 165.039L113.905 161.055L113.926 160.875L113.563 161.238L113.39 161.411Z",
    fill: "url(#paint15_linear_3074_7069)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.184 141.282L127.229 142.027L127.45 145.644L128.033 145.639L127.774 141.413L127.747 140.961L127.712 140.981L127.184 141.282Z",
    fill: "url(#paint16_linear_3074_7069)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0955 156.93L77.0325 157.513L76.6833 160.758L74.4375 164.026L74.6417 163.909L77.2288 160.145L77.5708 156.965L77.5498 156.964L77.0955 156.93Z",
    fill: "url(#paint17_linear_3074_7069)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M144.402 96.0449L144.368 96.1148L141.397 102.357L141.268 102.627L141.291 102.963L141.658 108.546L139.872 110.74L139.661 110.999L139.626 111.391L139.207 116.047L139.751 115.445L140.171 110.776L140.206 110.385L140.417 110.126L142.202 107.932L141.835 102.348L141.813 102.012L141.941 101.742L144.912 95.4997L144.946 95.4299L144.977 95.3845L150.063 87.7793L150.531 83.8967L150.547 83.7664L150.586 83.6713C152.19 79.8421 153.816 76.0287 155.453 72.2225L157.901 66.5085C158.009 66.255 158.12 66.0043 158.229 65.7516C158.766 64.3126 159.297 62.8686 159.833 61.4297C159.008 63.3281 158.167 65.215 157.355 67.1228L154.907 72.8368C153.27 76.6423 151.644 80.4557 150.04 84.2857L150 84.3807L149.984 84.5111L149.516 88.3936L144.43 95.9988L144.402 96.0449Z",
    fill: "url(#paint18_linear_3074_7069)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.621 120.02L135.848 120.767L137.42 125.945L138.075 125.69L136.393 120.153L136.169 119.414L136.085 119.508L135.621 120.02Z",
    fill: "url(#paint19_linear_3074_7069)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.799 127.758L133.699 127.796L133.552 127.987L130.494 131.926L130.211 132.291L130.242 132.807L130.629 139.006L131.192 138.685L130.788 132.193L130.756 131.677L131.039 131.312L133.799 127.758Z",
    fill: "url(#paint20_linear_3074_7069)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6172 166.518L70.6211 166.817L70.6789 171.041L71.2277 170.702L71.1666 166.203L70.8351 166.393L70.6172 166.518Z",
    fill: "url(#paint21_linear_3074_7069)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7344 158.573L36.7376 158.924L36.7751 162.573L32.9761 167.401L32.9269 167.464L32.9039 167.538L30.9023 174.083C31.0763 173.908 31.2483 173.729 31.4223 173.553L33.4494 166.923L33.4724 166.849L33.5216 166.787L37.3206 161.959L37.2832 158.31L37.2825 158.242L36.9832 158.423L36.7344 158.573Z",
    fill: "url(#paint22_linear_3074_7069)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3937 121.184L57.4009 121.156L56.988 121.231L56.8481 121.798L55.0284 129.178L54.9766 129.389L55.0002 129.596L55.4367 133.417L56.023 133.163L55.5457 128.983L55.5221 128.775L55.5739 128.564L57.3937 121.184Z",
    fill: "url(#paint23_linear_3074_7069)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2331 149.101L42.2048 149.349L41.5234 155.392L42.0342 155.083L42.7504 148.735L42.776 148.508L42.3854 148.933L42.2331 149.101Z",
    fill: "url(#paint24_linear_3074_7069)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9368 136.178L49.8317 136.516L47.8164 143.007L48.3534 142.421L50.3471 136L50.2086 136.06L49.9368 136.178Z",
    fill: "url(#paint25_linear_3074_7069)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9077 124.786L18.699 114.773L18.4345 114.974L18.3603 115.03L18.3163 115.107L12.3622 125.4C10.3718 128.824 8.94527 131.655 6.98047 135.107C7.72818 133.928 7.92118 133.352 8.66692 132.17C10.0764 129.704 11.4838 127.236 12.9077 124.786Z",
    fill: "url(#paint26_linear_3074_7069)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0953 79.6867L44.0478 72.3818L44.0786 72.1484L44.0662 72.1535L43.5869 72.3487L43.5023 72.9954L42.5977 79.9337L43.0953 79.6867Z",
    fill: "url(#paint27_linear_3074_7069)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5253 125.118L95.5397 124.702L95.7734 124.407L98.8975 120.469L98.6553 120.711L98.6166 120.75L98.5857 120.789L95.2279 125.021L94.9942 125.316L94.9798 125.732L94.8281 130.278L95.3677 129.843L95.5253 125.118Z",
    fill: "url(#paint28_linear_3074_7069)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9455 111.357L31.2012 99.2725L32.3579 95.9553L32.3776 95.8984L32.0185 96.2441L31.8787 96.3788L31.8124 96.5697L30.6557 99.8861L22.6836 111.555L22.9455 111.357Z",
    fill: "url(#paint29_linear_3074_7069)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M124.776 146.281L124.578 146.283L124.365 146.659L118.023 157.833L118.275 157.737L124.776 146.281Z",
    fill: "url(#paint30_linear_3074_7069)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4253 133.422L91.4555 133.172L91.2297 133.354L90.933 133.592L90.8798 134.035L90.3789 138.158L90.9014 137.733L91.4253 133.422Z",
    fill: "url(#paint31_linear_3074_7069)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M133.313 44.4105L128.916 51.1421L128.715 51.4496L128.819 51.8493L129.612 54.8972L130.181 54.3765L129.364 51.2357L129.26 50.836L129.461 50.5285L133.858 43.7969C135.897 38.8852 137.994 34.0152 140.066 29.1273C141.176 26.5116 142.289 23.8973 143.405 21.2859C144.209 19.2081 145.013 17.1304 145.809 15.0469C143.691 19.929 141.603 24.8335 139.52 29.7409C137.448 34.6289 135.352 39.4995 133.313 44.4105Z",
    fill: "url(#paint32_linear_3074_7069)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102.699 40.9609L103.282 40.6001L102.875 37.8634L102.814 37.4572L102.986 37.118L104.989 33.1612L105.001 27.1477L105.002 26.7926L105.171 26.529L110.674 17.9681L111.457 13.6311L111.493 13.4338L111.583 13.2883L114.971 7.85592L116.04 1.39581L116.08 1.15527L116.213 1.00114L118.534 -1.68661L120.102 -6.09201L120.116 -6.13018L120.129 -6.15755C123.383 -13.1448 126.672 -20.1033 129.968 -27.056L134.906 -37.4909L136.179 -40.1577L139.328 -47.2891L134.361 -36.878L129.423 -26.4432C126.126 -19.4904 122.837 -12.532 119.584 -5.54395L119.571 -5.51658L119.557 -5.47841L117.989 -1.073L115.668 1.61475L115.535 1.76887L115.495 2.00941L114.426 8.46952L111.039 13.9019L110.948 14.0474L110.913 14.2447L110.129 18.5817L104.626 27.1433L104.457 27.4069L104.456 27.762L104.444 33.7756L102.441 37.7323L102.27 38.0715L102.33 38.477L102.699 40.9609Z",
    fill: "url(#paint33_linear_3074_7069)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8804 94.3721L34.4325 93.8406L34.2769 91.9724L34.2408 91.5468L34.4798 91.232L37.5422 87.1939L38.9017 82.1447L38.9109 82.1094L38.8039 82.1627L38.4724 82.3269L38.3562 82.7583L36.9967 87.8075L33.9343 91.8456L33.6953 92.1603L33.7308 92.586L33.8804 94.3721Z",
    fill: "url(#paint34_linear_3074_7069)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0848 50.221L62.9905 42.9269L63.8485 34.075L63.8814 33.7344L63.6601 33.926L63.3509 34.1946L63.303 34.6886L62.445 43.5405L57.9102 50.2836L58.0848 50.221Z",
    fill: "url(#paint35_linear_3074_7069)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6676 69.8868L52.6563 60.057L52.6911 55.3325L52.6944 54.8961L52.9209 54.5763L54.9001 51.7812L54.7511 51.8345L54.5863 52.0672L52.3754 55.1899L52.1489 55.5097L52.1456 55.9461L52.1108 60.6706L48.3125 70.0316L48.6676 69.8868Z",
    fill: "url(#paint36_linear_3074_7069)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M94.257 55.874L98.9324 43.5703L98.7637 43.6747L98.5234 43.8231L98.4026 44.1414L93.7969 56.2637L94.257 55.874Z",
    fill: "url(#paint37_linear_3074_7069)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0907 29.0624L73.5691 20.3711L73.6196 16.9855L73.6249 16.6218L73.8015 16.3683L76.6282 12.3172L76.3459 10.6558L76.2698 10.2092L76.4969 9.88948L78.2503 7.42571L79.8842 1.63826L81.3495 -4.24281L80.9838 -4.35156L80.8414 -3.77829L79.3387 2.25186L77.7048 8.03931L75.9514 10.5031L75.7242 10.8228L75.8004 11.2694L76.0827 12.9308L73.2559 16.9819L73.0793 17.2354L73.0741 17.5991L73.0235 20.9855L68.6758 29.4218L69.0907 29.0624Z",
    fill: "url(#paint38_linear_3074_7069)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M152.016 72.0775L150.331 75.1916L148.8 76.4058L147.022 79.7511L143.602 83.3981L143.31 86.7369C143.31 86.7369 141.412 85.7553 141.267 85.1662C141.121 84.5771 139.661 90.0758 139.661 90.0758L136.742 94.0037L136.596 97.3425L133.092 100.485L128.095 112.805L122.934 118.329L121.268 125.231L119.37 125.82L118.349 129.552L117.765 136.033L115.722 137.211L116.305 140.156L114.554 141.728L111.342 148.405L112.364 151.155C112.364 151.155 110.612 154.691 110.466 155.28C110.32 155.869 110.904 159.011 110.904 159.011L109.153 159.6L108.86 161.761L106.817 164.706L101.124 178.846L108.86 167.455L113.823 165.491L114.407 161.171L116.45 159.207L118.64 158.421L125.5 146.637H128.858L128.565 141.335L132.069 139.371L131.631 132.104L134.697 128.176L139.222 126.409L137.178 119.731L140.535 116L140.973 110.894L143.017 108.34L142.579 102.252L145.498 95.9676L150.608 88.1118L151.045 83.9873L160.388 60.813L152.016 72.0775ZM102.883 107.807L107.449 104.387L108.243 97.0227L111.816 93.0775L114.199 86.5014L118.169 85.4492L117.375 79.6625L120.949 77.5581L120.551 73.8758L123.132 72.5607L122.338 66.774L126.11 63.3545L127.499 57.8307L130.874 54.6741L129.882 50.9917L134.249 44.1528L146.359 14.4305L121.94 50.2024L120.749 53.6219L118.566 55.7263L118.764 58.0935L115.587 62.3023L114.197 67.5626L110.028 69.667L109.036 77.5581L104.668 79.3996L100.499 89.9209V94.9183L98.3149 98.0749L95.5355 99.1271L90.3737 107.018L89.5794 116.224L84.6165 120.696L80.0508 129.902V133.585L77.0731 138.056L77.4703 140.161L75.6834 142.791L74.0954 148.84L72.7056 154.89L70.7205 154.364L70.5216 159.625L68.1393 164.096L67.7421 167.516L65.1616 171.461L66.1541 172.776L61.1913 182.771L69.7279 171.987L71.5148 170.934V166.2L74.8897 164.359L77.6692 160.414L78.0663 156.994L81.044 157.257L83.4263 150.418L87.1984 145.158L88.5881 140.686L91.5658 138.319L92.1612 133.585L96.1315 130.428L96.3298 125.168L99.7047 120.96L103.675 117.014L102.883 107.807ZM31.7147 99.7169L32.9364 96.3162L35.1388 94.2464L34.9616 91.8762L38.175 87.7178L39.6113 82.4792L43.7989 80.4403L44.8617 72.5658L49.2456 70.7927L53.5073 60.3369L53.552 55.3395L55.7636 52.2175L58.5523 51.2085L63.7836 43.3988L64.6594 34.2055L69.6616 29.8117L74.3087 20.6775L74.3415 16.9951L77.3586 12.5703L76.9805 10.4601L78.7904 7.85809L80.4322 1.8337L81.8758 -4.19429L83.8563 -3.63759L84.1019 -8.89426L86.5235 -13.3285L86.9509 -16.7415L89.5662 -20.6463L88.5855 -21.9765L93.637 -31.8935L81.4149 -19.9614L79.6189 -18.9373L79.5768 -14.2028L76.1862 -12.4145L73.3719 -8.51256L72.9446 -5.09958L69.9695 -5.40926L67.5268 1.39223L63.7088 6.59344L62.2797 11.0428L59.2809 13.3632L58.6435 18.0884L54.645 21.1823L54.3995 26.4397L50.9878 30.5952L46.9828 34.4785L47.695 43.6962L43.0991 47.0444L42.2398 54.3961L38.6319 58.2858L36.1911 64.8237L32.2117 65.814L32.9541 71.6122L29.3619 73.6605L29.7263 77.3485L27.1339 78.6233L27.8764 84.4215L24.0741 87.782L22.6358 93.2835L19.2334 96.3868L20.1931 100.084L15.7653 106.855L6.98047 135.106L19.173 114.82L23.243 111.838L31.7147 99.7169ZM62.0538 120.783L66.8185 110.612L74.4945 100.792L76.3477 92.0246L82.1712 85.3614L83.2301 74.928L88.5238 67.1247L90.9061 65.7218L91.1706 59.7601L94.8764 56.6034L99.641 43.9778L104.141 41.1719L103.612 37.6646L105.73 33.4558V27.1433L111.288 18.3758L112.082 13.817L115.523 8.20595L116.582 1.54275L118.965 -1.26312L120.553 -5.82193L139.876 -47.9062L120.553 -20.2005L120.751 -16.9568L117.641 -15.5539L112.281 -6.96127L108.046 -1.4374L106.523 5.40152L101.23 6.80445L100.701 13.1169L97.2594 20.1309L90.377 29.2492L86.4067 33.8087L86.1421 42.5763L82.4364 42.927L80.3186 46.4344L80.5832 52.7468L76.8775 60.4622L73.1717 62.9174L70.7894 69.9313L64.9659 78.3482L63.7751 83.872L58.6133 87.1158L59.4076 94.1297L53.5842 101.494L52.5253 108.158L48.0252 112.366L48.8195 116.926L45.1138 121.485L41.9372 127.797V133.057L38.2314 138.318L37.9669 144.981L34.7903 146.033L33.4668 151.293L20.2319 184.961L31.6136 173.738L33.7314 167.075L37.7017 162.165V158.307L42.4663 155.501L43.2606 148.838L48.8195 142.876L50.9373 136.213L56.7608 133.758L56.2317 128.849L58.0842 121.484L62.0538 120.783Z",
    fill: "url(#paint39_linear_3074_7069)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M157.913 66.5032L155.465 72.2172C153.828 76.0227 152.201 79.8361 150.598 83.666L150.558 83.7611L150.543 83.8915L150.075 87.774L144.988 95.3792L144.957 95.4246L144.924 95.4944L141.953 101.736L141.824 102.006L141.846 102.343L142.213 107.926L140.428 110.121L140.218 110.379L140.182 110.771L139.763 115.439L136.647 118.884L136.183 119.396L136.41 120.143L138.091 125.68L134.461 127.101L134.261 127.179L134.113 127.37L131.056 131.309L130.773 131.674L130.805 132.19L131.209 138.681L128.26 140.364L127.732 140.666L127.777 141.41L128.036 145.636L125.504 145.662L125.135 145.666L124.923 146.041L118.287 157.733L116.308 158.489L116.2 158.53L116.125 158.604L114.109 160.618L113.937 160.791L113.905 161.049L113.424 165.033L108.77 167.035L108.674 167.076L108.619 167.161L104.861 172.988C103.602 174.923 102.369 176.889 101.127 178.844C102.464 177.003 103.81 175.171 105.13 173.31L109.039 167.842L113.955 166.063L114.215 165.969L114.271 165.595L114.873 161.57L116.69 159.89L118.799 159.182L118.985 159.119L119.115 158.901L125.857 147.613L128.861 147.645L129.674 147.654L129.62 146.562L129.398 142.015L132.391 140.367L132.934 140.068L132.888 139.282L132.495 132.536L135.136 129.17L139.464 127.482L140.363 127.132L140.01 125.984L138.181 120.054L141.066 116.83L141.319 116.547L141.354 116.12L141.74 111.388L143.553 109.087L143.832 108.732L143.793 108.24L143.343 102.473L146.056 96.4869L151.042 88.6015L151.156 88.4222L151.175 88.2141L151.545 84.1853C153.04 80.3287 154.512 76.4569 155.974 72.578L158.197 66.7048C158.942 64.7502 159.658 62.7748 160.39 60.8101C159.566 62.7085 158.725 64.5954 157.913 66.5032ZM104.553 117.511L104.5 116.886L103.781 108.412L107.869 105.364L108.233 105.093L108.292 104.544L109.038 97.6039L112.355 93.9266L112.497 93.7703L112.574 93.5542L114.77 87.4636L118.333 86.5101L119.125 86.2983L118.978 85.2526L118.279 80.2833L121.268 78.4965L121.807 78.1739L121.721 77.4098L121.397 74.5196L123.404 73.4797L123.983 73.1794L123.87 72.3814L123.136 67.2003L126.493 64.0855L126.684 63.9083L126.751 63.6332L128.034 58.3384L131.212 55.2963L131.571 54.9521L131.422 54.4162L130.505 51.13L134.612 44.5532L134.646 44.4985L134.666 44.4466C136.655 39.4723 138.586 34.4562 140.541 29.4573C142.496 24.4578 144.445 19.4546 146.364 14.4298C144.246 19.312 142.158 24.2165 140.075 29.1239C138.003 34.0118 135.907 38.8817 133.868 43.7934L129.471 50.525L129.27 50.8326L129.374 51.2323L130.191 54.373L127.145 57.1558L126.983 57.3042L126.914 57.5685L125.554 62.7798L121.936 65.9839L121.552 66.3239L121.634 66.9418L122.296 71.9233L120.283 72.9316L119.72 73.2139L119.802 74.0155L120.103 76.9243L117.054 78.6924L116.482 79.0244L116.592 79.8498L117.226 84.5893L114.04 85.4255L113.637 85.5313L113.457 86.0254L111.145 92.376L107.705 96.1599L107.456 96.4343L107.41 96.8621L106.672 103.68L102.474 106.837L101.989 107.202L102.053 107.931L102.805 116.514L99.2196 120.091L99.1808 120.13L99.15 120.169L95.7922 124.401L95.5585 124.697L95.5447 125.112L95.3865 129.837L91.7838 132.738L91.4871 132.977L91.4332 133.42L90.91 137.731L88.2389 139.904L88.0387 140.067L87.9573 140.338L86.647 144.69L83.0056 149.881L82.9353 149.981L82.8986 150.091L80.7178 156.536L78.1031 156.343L77.6482 156.309L77.5851 156.892L77.2359 160.137L74.6488 163.902L71.3868 165.773L71.1689 165.898L71.1728 166.197L71.2339 170.696L69.6321 171.686L69.5894 171.711L69.5618 171.747C66.7614 175.405 63.9694 179.073 61.1952 182.768C64.1007 179.286 66.9879 175.781 69.8664 172.262L71.6323 171.272L71.7958 171.18L71.7991 170.931L71.8588 166.511L75.0486 164.859L75.1267 164.819L75.193 164.726L78.0092 160.827L78.1037 160.695L78.128 160.502L78.4792 157.684L81.0112 157.945L81.3644 157.982L81.5213 157.544L83.9161 150.863L87.6684 145.744L87.7479 145.636L87.7978 145.48L89.133 141.315L91.9394 139.136L92.2223 138.916L92.2801 138.473L92.8368 134.196L96.5294 131.298L96.8786 131.024L96.9016 130.476L97.1044 125.645L100.231 121.788L104.173 117.886L104.553 117.511ZM23.5286 112.328L23.5838 112.251L32.1592 100.257L32.2176 100.175L32.2609 100.058L33.4353 96.8808L35.5255 94.9629L35.8373 94.677L35.8025 94.1563L35.6745 92.2277L38.6844 88.4049L38.8006 88.2573L38.8603 88.0434L40.1969 83.2563L44.0681 81.4054L44.4843 81.2066L44.5663 80.6182L45.5727 73.4033L49.4859 71.8326L49.8082 71.703L49.9703 71.3069L54.2478 60.8627L54.3457 60.6228L54.3483 60.3456L54.3956 55.7868L56.2186 53.2142L58.7735 52.283L59.0171 52.1945L59.1825 51.9467L64.402 44.1233L64.5727 43.8669L64.6042 43.532L65.4196 34.822L70.0903 30.6665L70.2222 30.5491L70.3056 30.3835L74.9127 21.2133L75.0361 20.967L75.0368 20.6847L75.0459 17.3466L77.8438 13.1479L78.0768 12.7986L77.9954 12.365L77.679 10.6863L79.2348 8.39751L79.3215 8.27003L79.3596 8.126L80.943 2.1016L82.2185 -3.43737L83.7572 -3.02903L84.3001 -2.88499L84.3277 -3.60374L84.5213 -8.70918L86.8071 -13.0606L86.8584 -13.1578L86.8695 -13.2579L87.2365 -16.5744L89.737 -20.4504L89.8781 -20.6694L89.7291 -20.8638L88.8441 -22.0197C90.4558 -25.2995 92.0464 -28.5987 93.6357 -31.8993C91.8875 -28.6512 90.1407 -25.4025 88.4162 -22.1328L88.3236 -21.9571L88.4391 -21.7943L89.2525 -20.6492L86.7231 -17.013L86.668 -16.9337L86.6509 -16.8128L86.1914 -13.5265L83.7539 -9.23203L83.683 -9.10743L83.6732 -8.93459L83.4231 -4.41323L81.9775 -4.84247L81.5443 -4.97139L81.4012 -4.39811L79.8985 1.63205L78.2646 7.41949L76.5112 9.88327L76.284 10.2023L76.3602 10.6495L76.6431 12.311L73.8164 16.3621L73.6391 16.6156L73.6339 16.9793L73.5833 20.3656L69.1049 29.0569L64.2084 33.3031L63.8992 33.5718L63.8513 34.0665L62.9933 42.9177L58.0882 50.2125L55.5391 51.1278L55.308 51.2107L55.1433 51.4433L52.9323 54.566L52.7058 54.8858L52.7025 55.3222L52.6677 60.0467L48.6791 69.8766L44.6234 71.5294L44.1442 71.7246L44.0602 72.3713L43.1077 79.6769L39.352 81.5386L39.0198 81.7035L38.9037 82.1349L37.5441 87.1842L34.4817 91.2223L34.2428 91.5377L34.2782 91.9626L34.4344 93.8308L32.5688 95.627L32.429 95.7616L32.3627 95.9518L31.206 99.2682L22.9503 111.352L18.9806 114.356L18.9065 114.412L18.8618 114.489L12.9077 124.782C10.9173 128.206 8.94527 131.651 6.98047 135.103C9.07984 131.793 11.172 128.476 13.2451 125.138L19.429 115.233L23.4656 112.37L23.5286 112.328ZM62.153 121.748L62.4963 121.688L62.6821 121.295L67.4165 111.251L75.0459 101.544L75.1989 101.349L75.258 101.072L77.0619 92.6252L82.7154 86.1918L82.9524 85.9217L82.9957 85.5054L84.0395 75.4206L89.026 68.03L91.2416 66.7156L91.7011 66.4434L91.7293 65.7837L91.9584 60.3628L95.3097 57.4914L95.4955 57.3323L95.592 57.0745L100.213 44.7462L104.464 42.0772L105.001 41.7402L104.884 40.9746L104.408 37.8699L106.345 33.9988L106.47 33.7496L106.469 33.4558L106.456 27.4883L111.799 18.944L111.905 18.7755L111.939 18.5745L112.673 14.1907L115.984 8.70071L116.076 8.54731L116.104 8.36726L117.086 1.92228L119.313 -0.74387L119.397 -0.844696L119.441 -0.971447L120.991 -5.51945C124.172 -12.5478 127.319 -19.6049 130.457 -26.6678L135.181 -37.2755L139.876 -47.9062L134.909 -37.4952L129.971 -27.0603C126.674 -20.1076 123.385 -13.1491 120.132 -6.16186L120.119 -6.13449L120.105 -6.09632L118.537 -1.69091L116.216 0.996834L116.083 1.15096L116.043 1.3915L114.974 7.85161L111.586 13.284L111.495 13.4295L111.46 13.6268L110.676 17.9638L105.174 26.5247L105.004 26.7883L105.004 27.1433L104.991 33.1569L102.988 37.1137L102.817 37.4529L102.877 37.8591L103.284 40.5958L99.3134 43.0545L99.0738 43.2029L98.953 43.5212L94.262 55.8674L90.7328 58.8555L90.3875 59.1479L90.3619 59.696L90.1157 64.9915L88.187 66.1193L88.0269 66.213L87.9067 66.3894L82.5966 74.1732L82.42 74.4318L82.3859 74.7775L81.3887 84.8039L75.8186 91.2129L75.6328 91.4268L75.5685 91.7358L73.7908 100.239L66.2907 109.887L66.2211 109.976L66.1725 110.08L61.6108 119.878L57.9884 120.531L57.5361 120.613L57.3963 121.18L55.5765 128.559L55.5247 128.771L55.5483 128.978L56.0255 133.158L50.7535 135.445L50.4817 135.563L50.3767 135.901L48.3528 142.42L42.9442 148.32L42.7912 148.486L42.763 148.735L42.0468 155.083L37.5336 157.807L37.2842 157.957L37.2874 158.308L37.3249 161.957L33.5259 166.785L33.4767 166.847L33.4537 166.921L31.4265 173.552C27.684 177.335 23.9527 181.141 20.2312 184.962C24.0807 181.32 27.9204 177.661 31.7482 173.981L31.7961 173.935L31.8217 173.856L33.9802 167.314L37.9564 162.529L38.0732 162.389L38.0752 162.166L38.1113 158.67L42.6534 156.062L42.8805 155.931L42.9225 155.598L43.726 149.202L49.1734 143.458L49.2804 143.345L49.3382 143.167L51.3844 136.874L56.9597 134.591L57.4875 134.375L57.4127 133.636L56.9361 128.941L58.6245 122.36L62.153 121.748Z",
    fill: "#F8FEFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M157.214 66.0032L154.766 71.7172C153.129 75.5227 151.503 79.3361 149.899 83.1661L149.86 83.2611L149.844 83.3915L149.376 87.274L144.29 94.8792L144.259 94.9246L144.226 94.9945L141.255 101.236L141.126 101.506L141.148 101.843L141.515 107.426L139.73 109.62L139.519 109.879L139.484 110.271L139.064 114.939L135.947 118.384L135.484 118.896L135.711 119.643L137.392 125.18L133.762 126.601L133.562 126.679L133.414 126.87L130.357 130.809L130.073 131.174L130.105 131.69L130.51 138.181L127.561 139.864L127.033 140.166L127.078 140.91L127.336 145.136L124.805 145.162L124.436 145.167L124.224 145.542L117.588 157.234L115.609 157.99L115.5 158.031L115.426 158.105L113.41 160.118L113.238 160.291L113.206 160.55L112.725 164.534L108.071 166.536L107.975 166.577L107.92 166.662L104.161 172.488C102.903 174.424 101.67 176.39 100.429 178.345C101.766 176.503 103.112 174.672 104.432 172.811L108.34 167.343L113.257 165.564L113.517 165.471L113.572 165.096L114.174 161.071L115.991 159.392L118.1 158.684L118.286 158.621L118.416 158.404L125.158 147.115L128.162 147.147L128.976 147.156L128.922 146.064L128.7 141.517L131.693 139.87L132.236 139.571L132.19 138.784L131.796 132.038L134.437 128.672L138.766 126.985L139.665 126.634L139.311 125.487L137.482 119.557L140.367 116.332L140.621 116.049L140.655 115.622L141.041 110.891L142.855 108.589L143.134 108.234L143.095 107.742L142.645 101.975L145.357 95.989L150.344 88.1037L150.457 87.9244L150.476 87.7162L150.846 83.6875C152.341 79.8309 153.814 75.9591 155.276 72.0802L157.498 66.207C158.243 64.2524 158.96 62.2769 159.692 60.3123C158.867 62.2085 158.025 64.0954 157.214 66.0032ZM103.853 117.011L103.8 116.386L103.081 107.912L107.17 104.864L107.534 104.593L107.593 104.044L108.338 97.1039L111.656 93.4266L111.797 93.2703L111.875 93.0543L114.071 86.9636L117.635 86.0101L118.426 85.7984L118.279 84.7526L117.581 79.7833L120.569 77.9965L121.109 77.6739L121.023 76.9098L120.698 74.0196L122.704 72.9797L123.283 72.6794L123.171 71.8814L122.437 66.6996L125.794 63.5848L125.985 63.4076L126.052 63.1325L127.335 57.8377L130.512 54.7956L130.872 54.4513L130.722 53.9155L129.805 50.6293L133.912 44.0525L133.946 43.9978L133.967 43.9459C135.956 38.9716 137.887 33.9547 139.843 28.9566C141.797 23.957 143.746 18.9539 145.665 13.9291C143.547 18.8113 141.46 23.7158 139.377 28.6239C137.306 33.5118 135.209 38.3817 133.17 43.2934L128.773 50.0258L128.572 50.3333L128.676 50.733L129.493 53.8738L126.447 56.6566L126.285 56.8049L126.216 57.0692L124.856 62.2805L121.238 65.4854L120.854 65.8253L120.936 66.4432L121.598 71.4248L119.585 72.4331L119.022 72.7154L119.104 73.5169L119.405 76.4258L116.356 78.1931L115.784 78.5252L115.894 79.3505L116.528 84.0901L113.342 84.9262L112.939 85.0321L112.759 85.5261L110.447 91.8768L107.006 95.6606L106.757 95.935L106.711 96.3628L105.973 103.181L101.775 106.338L101.291 106.703L101.354 107.431L102.107 116.015L98.5216 119.592L98.4829 119.631L98.452 119.67L95.0942 123.902L94.8605 124.197L94.8467 124.614L94.6885 129.339L91.0859 132.24L90.7891 132.479L90.7353 132.922L90.2121 137.233L87.541 139.406L87.3407 139.568L87.2593 139.839L85.949 144.191L82.3076 149.383L82.2374 149.483L82.2006 149.592L80.0198 156.037L77.4052 155.844L76.9502 155.81L76.8872 156.394L76.538 159.639L73.9508 163.403L70.6889 165.274L70.4709 165.4L70.4749 165.698L70.5359 170.197L68.9341 171.187L68.8915 171.213L68.8639 171.249C66.0634 174.905 63.2715 178.575 60.4973 182.269C63.4021 178.788 66.2899 175.282 69.1685 171.764L70.9344 170.774L71.0985 170.681L71.1018 170.432L71.1622 166.012L74.3519 164.36L74.4301 164.32L74.4964 164.228L77.3126 160.328L77.4071 160.197L77.4314 160.004L77.7826 157.186L80.3146 157.446L80.6678 157.483L80.8247 157.045L83.2194 150.365L86.9718 145.245L87.0512 145.137L87.1011 144.981L88.4364 140.817L91.2428 138.637L91.5257 138.418L91.5835 137.975L92.1402 133.698L95.8328 130.799L96.182 130.526L96.205 129.978L96.4078 125.146L99.5346 121.289L103.477 117.387L103.853 117.011ZM22.8294 111.828L22.8845 111.751L31.4599 99.7571L31.5183 99.675L31.5616 99.5576L32.7361 96.3808L34.8262 94.463L35.1381 94.177L35.1033 93.6563L34.9753 91.7284L37.9851 87.9056L38.1013 87.758L38.1611 87.5448L39.4976 82.7577L43.3688 80.9061L43.785 80.7073L43.8671 80.1189L44.8734 72.9048L48.7873 71.3341L49.1096 71.2044L49.2717 70.8083L53.5493 60.3641L53.6477 60.1243L53.6504 59.8477L53.6976 55.2889L55.5206 52.7164L58.0756 51.7852L58.3191 51.6966L58.4846 51.4489L63.7041 43.6255L63.8748 43.3691L63.9063 43.0342L64.7216 34.3242L69.3924 30.1687L69.5243 30.0513L69.6077 29.8857L74.2147 20.7155L74.3382 20.4692L74.3388 20.1868L74.348 16.8488L77.1459 12.6508L77.3789 12.3015L77.2975 11.8679L76.9811 10.1892L78.5369 7.90039L78.6236 7.77292L78.6616 7.62888L80.245 1.6045L81.5205 -3.93449L83.0593 -3.52614L83.6022 -3.38211L83.6297 -4.10086L83.8241 -9.20629L86.1099 -13.5577L86.1611 -13.6549L86.1722 -13.755L86.5398 -17.0715L89.0397 -20.9475L89.1808 -21.1665L89.0318 -21.3609L88.1469 -22.5168C89.7585 -25.7966 91.3491 -29.0958 92.9384 -32.3964C91.1902 -29.1484 89.4434 -25.8996 87.7189 -22.6299L87.6263 -22.4542L87.7418 -22.2914L88.5552 -21.1463L86.0258 -17.5101L85.9707 -17.4301L85.9536 -17.3091L85.4941 -14.0229L83.0567 -9.72842L82.9858 -9.60383L82.9759 -9.43098L82.7258 -4.90963L81.2803 -5.33886L80.847 -5.46778L80.7039 -4.8945L79.2012 1.13565L77.5673 6.9231L75.8139 9.38688L75.5868 9.70592L75.6629 10.1532L75.9458 11.8139L73.1191 15.865L72.9425 16.1185L72.9373 16.4815L72.8867 19.8678L68.4083 28.5591L63.5118 32.8053L63.2026 33.0739L63.1546 33.5687L62.2966 42.4198L57.3915 49.7146L54.8425 50.63L54.6114 50.7128L54.4466 50.9455L52.2357 54.0682L52.0092 54.388L52.0059 54.8244L51.9711 59.5489L47.9824 69.3787L43.9268 71.0316L43.4476 71.2267L43.3636 71.8735L42.411 79.1791L38.6554 81.0408L38.3232 81.2057L38.207 81.6371L36.8482 86.6864L33.7857 90.7245L33.5468 91.0399L33.5822 91.4648L33.7385 93.333L31.8728 95.1291L31.733 95.2638L31.6667 95.4539L30.51 98.7704L22.2543 110.855L18.2847 113.859L18.2105 113.915L18.1665 113.992L12.2124 124.285C10.222 127.709 8.24995 131.154 6.28516 134.606C8.38387 131.296 10.4767 127.978 12.5498 124.641L18.7337 114.736L22.7709 111.874L22.8294 111.828ZM61.4544 121.248L61.7977 121.189L61.9828 120.795L66.7173 110.751L74.3467 101.044L74.4996 100.849L74.5587 100.572L76.3627 92.1252L82.0162 85.6918L82.2531 85.4217L82.2965 85.0054L83.3402 74.9206L88.3267 67.53L90.5423 66.2157L91.0018 65.9434L91.0294 65.2837L91.2592 59.8629L94.6104 56.9915L94.7962 56.8323L94.8927 56.5745L99.5135 44.2463L103.765 41.5772L104.302 41.2402L104.184 40.4746L103.709 37.3699L105.646 33.4988L105.77 33.2497L105.77 32.9558L105.757 26.9883L111.1 18.444L111.206 18.2755L111.239 18.0745L111.974 13.6907L115.284 8.20072L115.377 8.04732L115.405 7.86728L116.387 1.42229L118.613 -1.24385L118.698 -1.34468L118.741 -1.47144L120.291 -6.01944C123.473 -13.0478 126.62 -20.1049 129.758 -27.1678L134.481 -37.7755L139.176 -48.4062L134.209 -37.9952L129.271 -27.5603C125.974 -20.6076 122.685 -13.6491 119.432 -6.66113L119.419 -6.63376L119.405 -6.5956L117.837 -2.19019L115.516 0.497566L115.383 0.651676L115.343 0.89222L114.274 7.35233L110.887 12.7847L110.796 12.9302L110.761 13.1275L109.977 17.4645L104.474 26.0261L104.305 26.2897L104.304 26.6448L104.292 32.6584L102.289 36.6151L102.118 36.9543L102.178 37.3605L102.586 40.0972L98.6142 42.556L98.3746 42.7043L98.2538 43.0226L93.5627 55.3689L90.0335 58.3569L89.6882 58.6493L89.6626 59.1974L89.4165 64.493L87.4878 65.6201L87.3276 65.7137L87.2075 65.8901L81.8973 73.674L81.7207 73.9325L81.6866 74.2782L80.6894 84.3047L75.1193 90.7136L74.9336 90.9276L74.8692 91.2365L73.0915 99.7398L65.5908 109.387L65.5212 109.477L65.4726 109.581L60.9108 119.379L57.2885 120.032L56.8362 120.113L56.6963 120.681L54.8766 128.06L54.8241 128.272L54.8477 128.479L55.325 132.659L50.0529 134.946L49.7812 135.064L49.6761 135.401L47.6522 141.921L42.2436 147.82L42.0907 147.987L42.0624 148.235L41.3469 154.584L36.8337 157.307L36.5843 157.458L36.5882 157.809L36.6256 161.457L32.8267 166.285L32.7774 166.347L32.7551 166.422L30.7279 173.052C26.9848 176.835 23.2541 180.641 19.5326 184.462C23.3821 180.82 27.2218 177.161 31.0496 173.481L31.0975 173.435L31.1231 173.356L33.2816 166.814L37.2578 162.029L37.3746 161.889L37.3766 161.666L37.4127 158.17L41.9548 155.562L42.1813 155.431L42.2233 155.098L43.0268 148.702L48.4741 142.958L48.5811 142.845L48.6389 142.667L50.6851 136.374L56.2604 134.091L56.7882 133.875L56.7134 133.136L56.2375 128.441L57.9259 121.86L61.4544 121.248Z",
    fill: "url(#paint40_radial_3074_7069)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5831 151.41L34.9072 146.149L38.0831 145.097L38.3477 138.433L42.0534 133.173V127.912L45.2301 121.6L48.9358 117.041L48.1415 112.481L52.6415 108.273L53.7004 101.609L59.5239 94.2446L58.7296 87.2307L63.8913 83.987L65.0822 78.4631L70.9057 70.0462L73.288 63.0323L76.9937 60.5772L80.6995 52.8617L80.4349 46.5493L82.5526 43.042L86.2584 42.6912L86.5229 33.9236L90.4932 29.3648L97.3756 20.2465L100.817 13.2326L101.346 6.91937L106.64 5.51645L108.162 -1.32177L112.397 -6.84562L117.757 -15.4382L120.867 -16.8404L120.669 -20.0849L136.421 -42.6715L138.933 -48.1406L119.61 -20.4356L119.809 -17.1912L116.699 -15.7889L111.339 -7.19636L107.103 -1.6725L105.581 5.16571L100.287 6.56864L99.7579 12.8818L96.3167 19.8958L89.4344 29.0141L85.4641 33.5729L85.1995 42.3405L81.4938 42.6912L79.376 46.1986L79.6406 52.511L75.9348 60.2264L72.2291 62.6815L69.8468 69.6955L64.0233 78.1124L62.8325 83.6362L57.6707 86.88L58.465 93.8939L52.6415 101.259L51.5826 107.922L47.0833 112.131L47.8769 116.69L44.1712 121.249L40.9952 127.561V132.822L37.2895 138.083L37.0243 144.746L33.8483 145.798L32.5249 151.059L20.2148 184.961L21.2435 182.8L33.5831 151.41Z",
    fill: "url(#paint41_linear_3074_7069)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8966 106.968L20.3244 100.197L19.3647 96.4997L22.7671 93.3964L24.2061 87.8949L28.0077 84.5344L27.2652 78.7355L29.8576 77.4607L29.4932 73.7726L33.0854 71.7244L32.3423 65.9254L36.3218 64.9352L38.7625 58.3973L42.3704 54.5075L43.2297 47.1558L47.8263 43.8077L47.114 34.59L51.1191 30.7067L54.5308 26.5512L54.7763 21.2945L58.7742 18.1999L59.4122 13.4754L62.4103 11.1542L63.8401 6.7049L67.6581 1.50368L70.1008 -5.29779L73.0765 -4.98811L73.5039 -8.40109L76.3182 -12.3031L79.7088 -14.0913L79.7508 -18.8259L81.5469 -19.85L91.3079 -29.3788L92.7101 -32.1328L80.488 -20.2007L78.6919 -19.1766L78.6499 -14.4421L75.2593 -12.6538L72.445 -8.75183L72.0177 -5.33884L69.0426 -5.64853L66.5992 1.15295L62.7812 6.35416L61.3521 10.8035L58.3534 13.1247L57.7159 17.8491L53.7174 20.9438L53.4719 26.2005L50.0603 30.356L46.0552 34.2392L46.7674 43.4569L42.1715 46.8051L41.3116 54.1568L37.7036 58.0466L35.2629 64.5844L31.2834 65.5747L32.0265 71.3737L28.4344 73.4219L28.7987 77.11L26.2063 78.3847L26.9494 84.1837L23.1472 87.5441L21.7089 93.0456L18.3058 96.1489L19.2655 99.8464L14.8377 106.617L6.98047 135.1L8.47458 130.842L15.8966 106.968Z",
    fill: "url(#paint42_linear_3074_7069)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M142.683 83.1626L142.414 86.2414C142.931 86.582 143.45 86.8521 143.45 86.8521L143.742 83.5133L147.162 79.8663L148.939 76.5217L150.47 75.3075L152.156 72.1934L157.906 64.4571L159.47 60.5781L151.097 71.8433L149.411 74.9574L147.88 76.1717L146.103 79.517L142.683 83.1626Z",
    fill: "url(#paint43_linear_3074_7069)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M106.941 164.826L108.984 161.88L109.277 159.719L111.028 159.13C111.028 159.13 110.444 155.988 110.59 155.399C110.736 154.81 112.488 151.274 112.488 151.274L111.467 148.525L114.678 141.847L116.429 140.276L115.846 137.33L117.889 136.152L118.473 129.671L119.495 125.94L121.393 125.35L123.058 118.448L128.22 112.924L133.217 100.604L136.721 97.4618L136.866 94.123L139.786 90.1951C139.786 90.1951 140.639 86.9823 141.106 85.7349C140.725 85.4634 140.39 85.1689 140.333 84.9348C140.187 84.3457 138.727 89.8451 138.727 89.8451L135.808 93.773L135.662 97.1118L132.158 100.254L127.161 112.574L122 118.098L120.334 125L118.436 125.59L117.415 129.321L116.831 135.802L114.787 136.98L115.371 139.926L113.619 141.498L110.408 148.175L111.43 150.925C111.43 150.925 109.678 154.461 109.532 155.05C109.386 155.639 109.97 158.781 109.97 158.781L108.218 159.37L107.926 161.531L105.883 164.476L101.168 178.726L103.137 174.278L106.941 164.826Z",
    fill: "url(#paint44_linear_3074_7069)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2771 172.889L65.2846 171.573L67.8651 167.628L68.2623 164.209L70.6446 159.737L70.8428 154.477L72.828 155.003L74.2177 148.953L75.8064 142.903L77.5926 140.273L77.1961 138.169L80.1738 133.697V130.015L84.7395 120.809L89.703 116.338L90.4967 107.132L95.6585 99.2404L98.438 98.189L100.621 95.0324V90.035L104.791 79.5137L109.158 77.6722L110.151 69.7818L114.32 67.6774L115.71 62.4171L118.885 58.2083L118.687 55.841L120.871 53.7367L122.062 50.3179L143.5 18.9126L145.422 14.1953L121.003 49.9672L119.812 53.3859L117.628 55.4903L117.827 57.8576L114.651 62.0664L113.261 67.3266L109.092 69.431L108.099 77.3214L103.732 79.163L99.5625 89.6842V94.6816L97.3791 97.8382L94.5996 98.8904L89.4378 106.781L88.6442 115.987L83.6807 120.459L79.1149 129.664V133.347L76.1372 137.818L76.5337 139.923L74.7475 142.553L73.1588 148.602L71.7698 154.652L69.784 154.126L69.5857 159.386L67.2034 163.858L66.8062 167.278L64.2257 171.223L65.2183 172.538L61.1797 182.767L63.5633 178.354L66.2771 172.889Z",
    fill: "url(#paint45_linear_3074_7069)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3074_7069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: -48,
    width: 155,
    height: 233
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M160.385 60.8125L151.043 83.9868L150.605 88.1113L145.495 95.9672L142.576 102.252L143.014 108.34L140.97 110.893L140.533 115.999L137.175 119.731L139.219 126.408L134.694 128.175L131.628 132.103L132.066 139.37L128.563 141.334L128.855 146.637H125.498L118.637 158.421L116.448 159.206L114.404 161.17L113.82 165.491L108.858 167.455L101.121 178.846L106.814 164.706L108.858 161.76L109.15 159.6L110.901 159.01C110.901 159.01 110.318 155.868 110.463 155.279C110.609 154.69 112.361 151.155 112.361 151.155L111.34 148.405L114.551 141.727L116.302 140.156L115.719 137.21L117.762 136.032L118.346 129.551L119.368 125.82L121.265 125.231L122.931 118.328L128.093 112.804L133.09 100.484L136.593 97.342L136.739 94.0032L139.658 90.0753C139.658 90.0753 141.118 84.5759 141.264 85.165C141.41 85.7541 143.307 86.7365 143.307 86.7365L143.6 83.3977L147.019 79.7506L148.797 76.4061L150.328 75.1918L152.013 72.0777L160.385 60.8125Z",
    fill: "#2C3A44"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M146.347 14.4375L121.928 50.2094L120.737 53.6281L118.553 55.7325L118.752 58.0998L115.576 62.3086L114.186 67.5688L110.017 69.6732L109.024 77.5644L104.657 79.4052L100.487 89.9264V94.9238L98.304 98.0804L95.5246 99.1319L90.3628 107.023L89.5691 116.229L84.6056 120.701L80.0399 129.906V133.589L77.0622 138.06L77.4587 140.165L75.6724 142.795L74.0838 148.844L72.6941 154.894L70.7089 154.368L70.5107 159.629L68.1284 164.1L67.7312 167.52L65.1506 171.465L66.1432 172.78L61.1797 182.775L69.7164 171.991L71.5032 170.939V166.205L74.8781 164.363L77.6576 160.418L78.0548 156.998L81.0325 157.261L83.4148 150.422L87.1868 145.162L88.5759 140.69L91.5543 138.323L92.1497 133.589L96.12 130.433L96.3189 125.172L99.6938 120.964L103.664 117.019L102.87 107.812L107.436 104.393L108.23 97.0282L111.804 93.0823L114.186 86.507L118.156 85.4548L117.362 79.668L120.936 77.5644L120.538 73.8813L123.119 72.5662L122.325 66.7795L126.097 63.3608L127.486 57.8369L130.861 54.6803L129.869 50.998L134.237 44.159L146.347 14.4375Z",
    fill: "url(#paint46_linear_3074_7069)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98047 135.109L19.173 114.824L23.243 111.841L31.7147 99.7199L32.9357 96.3198L35.1382 94.2493L34.9609 91.8792L38.1743 87.7208L39.6107 82.4821L43.7983 80.4432L44.8604 72.568L49.2443 70.7948L53.506 60.3398L53.5507 55.3424L55.7623 52.2204L58.551 51.2114L63.7817 43.4017L64.6574 34.2085L69.6603 29.8146L74.3074 20.6804L74.3402 16.9988L77.3573 12.5739L76.9792 10.4638L78.7891 7.86101L80.4309 1.83661L81.8745 -4.19066L83.8544 -3.63395L84.0999 -8.89062L86.5216 -13.3248L86.9489 -16.7378L89.5643 -20.6427L88.5835 -21.9736L93.635 -31.8906L81.413 -19.9585L79.6169 -18.9344L79.5749 -14.1999L76.1842 -12.4116L73.37 -8.50964L72.9426 -5.09666L69.9669 -5.40634L67.5242 1.39514L63.7062 6.59636L62.2764 11.0457L59.2783 13.3669L58.6402 18.0913L54.6424 21.186L54.3969 26.4426L50.9852 30.5981L46.9801 34.4814L47.6924 43.6991L43.0958 47.0473L42.2365 54.399L38.6286 58.2887L36.1879 64.8266L32.2084 65.8169L32.9515 71.6159L29.3593 73.6641L29.7237 77.3522L27.1313 78.6269L27.8737 84.4259L24.0722 87.7863L22.6332 93.2878L19.2307 96.3911L20.1905 100.089L15.7626 106.859L6.98047 135.109Z",
    fill: "#2C3A44"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98047 135.109L19.173 114.824L23.243 111.841L31.7147 99.7199L32.9357 96.3198L35.1382 94.2493L34.9609 91.8792L38.1743 87.7208L39.6107 82.4821L43.7983 80.4432L44.8604 72.568L49.2443 70.7948L53.506 60.3398L53.5507 55.3424L55.7623 52.2204L58.551 51.2114L63.7817 43.4017L64.6574 34.2085L69.6603 29.8146L74.3074 20.6804L74.3402 16.9988L77.3573 12.5739L76.9792 10.4638L78.7891 7.86101L80.4309 1.83661L81.8745 -4.19066L83.8544 -3.63395L84.0999 -8.89062L86.5216 -13.3248L86.9489 -16.7378L89.5643 -20.6427L88.5835 -21.9736L93.635 -31.8906L81.413 -19.9585L79.6169 -18.9344L79.5749 -14.1999L76.1842 -12.4116L73.37 -8.50964L72.9426 -5.09666L69.9669 -5.40634L67.5242 1.39514L63.7062 6.59636L62.2764 11.0457L59.2783 13.3669L58.6402 18.0913L54.6424 21.186L54.3969 26.4426L50.9852 30.5981L46.9801 34.4814L47.6924 43.6991L43.0958 47.0473L42.2365 54.399L38.6286 58.2887L36.1879 64.8266L32.2084 65.8169L32.9515 71.6159L29.3593 73.6641L29.7237 77.3522L27.1313 78.6269L27.8737 84.4259L24.0722 87.7863L22.6332 93.2878L19.2307 96.3911L20.1905 100.089L15.7626 106.859L6.98047 135.109Z",
    fill: "url(#paint47_linear_3074_7069)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M139.874 -47.9062L120.551 -5.82119L118.963 -1.26239L116.58 1.54347L115.521 8.20668L112.08 13.8184L111.286 18.3772L105.728 27.1448V33.4573L103.61 37.6661L104.14 41.1727L99.6396 43.9785L94.875 56.6042L91.1693 59.7601L90.9047 65.7225L88.5224 67.1247L83.228 74.928L82.1691 85.3614L76.3463 92.0253L74.4931 100.793L66.8171 110.612L62.0525 120.783L58.0822 121.484L56.229 128.849L56.7587 133.759L50.9352 136.213L48.8175 142.877L43.2586 148.839L42.4649 155.502L37.7003 158.308V162.166L33.73 167.076L31.6122 173.739L20.2305 184.962L33.4648 151.294L34.7882 146.033L37.9648 144.982L38.2294 138.318L41.9351 133.057V127.797L45.1118 121.484L48.8175 116.925L48.0232 112.366L52.5232 108.158L53.5821 101.494L59.4056 94.129L58.6113 87.1151L63.7731 83.8713L64.9639 78.3475L70.7874 69.9306L73.1697 62.9167L76.8754 60.4616L80.5812 52.7461L80.3166 46.4337L82.4344 42.9263L86.1401 42.5756L86.4046 33.808L90.3749 29.2492L97.2573 20.1309L100.699 13.1169L101.228 6.80375L106.521 5.40081L108.044 -1.43739L112.279 -6.96126L117.639 -15.5531L120.749 -16.9561L120.551 -20.2005L139.874 -47.9062Z",
    fill: "#2C3A44"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M139.874 -47.9062L120.551 -5.82119L118.963 -1.26239L116.58 1.54347L115.521 8.20668L112.08 13.8184L111.286 18.3772L105.728 27.1448V33.4573L103.61 37.6661L104.14 41.1727L99.6396 43.9785L94.875 56.6042L91.1693 59.7601L90.9047 65.7225L88.5224 67.1247L83.228 74.928L82.1691 85.3614L76.3463 92.0253L74.4931 100.793L66.8171 110.612L62.0525 120.783L58.0822 121.484L56.229 128.849L56.7587 133.759L50.9352 136.213L48.8175 142.877L43.2586 148.839L42.4649 155.502L37.7003 158.308V162.166L33.73 167.076L31.6122 173.739L20.2305 184.962L33.4648 151.294L34.7882 146.033L37.9648 144.982L38.2294 138.318L41.9351 133.057V127.797L45.1118 121.484L48.8175 116.925L48.0232 112.366L52.5232 108.158L53.5821 101.494L59.4056 94.129L58.6113 87.1151L63.7731 83.8713L64.9639 78.3475L70.7874 69.9306L73.1697 62.9167L76.8754 60.4616L80.5812 52.7461L80.3166 46.4337L82.4344 42.9263L86.1401 42.5756L86.4046 33.808L90.3749 29.2492L97.2573 20.1309L100.699 13.1169L101.228 6.80375L106.521 5.40081L108.044 -1.43739L112.279 -6.96126L117.639 -15.5531L120.749 -16.9561L120.551 -20.2005L139.874 -47.9062Z",
    fill: "url(#paint48_linear_3074_7069)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3074_7069)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddn_3074_7069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.613 81.402C162.613 124.478 127.693 159.398 84.6168 159.398C41.541 159.398 6.62109 124.478 6.62109 81.402C6.62109 38.3261 41.541 3.40625 84.6168 3.40625C127.693 3.40625 162.613 38.3261 162.613 81.402Z",
    fill: "#EEBB4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.613 81.402C162.613 124.478 127.693 159.398 84.6168 159.398C41.541 159.398 6.62109 124.478 6.62109 81.402C6.62109 38.3261 41.541 3.40625 84.6168 3.40625C127.693 3.40625 162.613 38.3261 162.613 81.402Z",
    fill: "#EEBB4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7412 3.64355C94.8698 3.96423 98.9079 4.60731 102.831 5.5459L102.096 8.62207C105.941 9.54209 109.672 10.7587 113.261 12.2471L114.472 9.3252C118.266 10.8986 121.909 12.7633 125.373 14.8906L123.719 17.5859C127.067 19.6423 130.242 21.9551 133.216 24.4971L135.27 22.0928C138.375 24.7478 141.27 27.6423 143.925 30.748L141.521 32.8037C144.063 35.7772 146.376 38.9522 148.433 42.3008L151.128 40.6445C153.255 44.1087 155.119 47.7518 156.692 51.5459L153.771 52.7578C155.26 56.3469 156.476 60.0775 157.396 63.9229L160.472 63.1865C161.41 67.1098 162.053 71.1478 162.374 75.2764L159.221 75.5215C159.371 77.4612 159.448 79.4227 159.448 81.4023C159.448 83.3818 159.371 85.3427 159.221 87.2822L162.374 87.5264C162.053 91.655 161.41 95.693 160.472 99.6162L157.396 98.8809C156.476 102.726 155.26 106.457 153.771 110.046L156.692 111.257C155.119 115.051 153.255 118.694 151.128 122.158L148.433 120.504C146.376 123.852 144.063 127.028 141.521 130.001L143.926 132.056C141.271 135.161 138.376 138.056 135.271 140.711L133.216 138.307C130.242 140.849 127.067 143.161 123.719 145.218L125.373 147.913C121.909 150.04 118.266 151.904 114.472 153.478L113.261 150.557C109.672 152.045 105.941 153.262 102.096 154.182L102.831 157.257C98.9078 158.195 94.8698 158.838 90.7412 159.159L90.4971 156.006C88.5575 156.157 86.5966 156.233 84.6172 156.233C82.6376 156.233 80.6761 156.157 78.7363 156.006L78.4912 159.159C74.3626 158.838 70.3246 158.196 66.4014 157.257L67.1377 154.182C63.2923 153.262 59.5618 152.045 55.9727 150.557L54.7607 153.478C50.9666 151.904 47.3235 150.04 43.8594 147.913L45.5156 145.218C42.167 143.161 38.992 140.849 36.0186 138.307L33.9629 140.71C30.8572 138.055 27.9626 135.16 25.3076 132.055L27.7119 130.001C25.1699 127.027 22.8571 123.852 20.8008 120.504L18.1055 122.158C15.9781 118.694 14.1134 115.051 12.54 111.257L15.4619 110.046C13.9736 106.457 12.7569 102.726 11.8369 98.8809L8.76074 99.6162C7.82216 95.693 7.17908 91.6549 6.8584 87.5264L10.0127 87.2822C9.89967 85.8274 9.82846 84.3605 9.7998 82.8828L9.78516 81.4023C9.78516 79.4227 9.862 77.4612 10.0127 75.5215L6.8584 75.2764C7.17914 71.1478 7.8221 67.1097 8.76074 63.1865L11.8369 63.9229C12.7569 60.0775 13.9736 56.3469 15.4619 52.7578L12.54 51.5459C14.1135 47.7516 15.9781 44.1088 18.1055 40.6445L20.8008 42.3008C22.8571 38.9522 25.17 35.7772 27.7119 32.8037L25.3076 30.748C27.9626 27.6423 30.8572 24.7478 33.9629 22.0928L36.0186 24.4971C38.992 21.9551 42.1671 19.6422 45.5156 17.5859L43.8594 14.8906C47.3236 12.7633 50.9665 10.8986 54.7607 9.3252L55.9727 12.2471C59.5618 10.7587 63.2923 9.54209 67.1377 8.62207L66.4014 5.5459C70.3245 4.60726 74.3627 3.9643 78.4912 3.64355L78.7363 6.79785C80.6761 6.64716 82.6376 6.57031 84.6172 6.57031C86.5966 6.57032 88.5575 6.64718 90.4971 6.79785L90.7412 3.64355Z",
    stroke: "#FFEBB2",
    strokeWidth: 6.32825,
    strokeDasharray: "12.66 12.66"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iin_3074_7069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84.6177,
    cy: 81.4029,
    r: 71.6675,
    transform: "rotate(180 84.6177 81.4029)",
    fill: "#005754"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.6177,
    cy: 81.4029,
    r: 71.6675,
    transform: "rotate(180 84.6177 81.4029)",
    fill: "url(#paint49_linear_3074_7069)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_in_3074_7069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.394 93.2289H48.2188V72.1683H85.9926V93.2289H121.034V69.5391",
    stroke: "#EBBD6A",
    strokeWidth: 5.23869
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddn_3074_7069",
    x: 3.5097,
    y: 2.35154,
    width: 161.899,
    height: 161.899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.421884,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3074_7069"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.158206,
    dy: 1.89848
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3074_7069"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.421884,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3074_7069"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.158206,
    dy: 0.632825
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.316413
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3074_7069",
    result: "effect2_dropShadow_3074_7069"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "6.3208580017089844 6.3208580017089844",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2402
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.08)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_3074_7069"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect3_noise_3074_7069",
    in2: "effect2_dropShadow_3074_7069",
    result: "effect3_noise_3074_7069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iin_3074_7069",
    x: 12.9492,
    y: 8.46872,
    width: 143.811,
    height: 146.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.474619,
    dy: 1.89848
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89848
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3074_7069"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.26565
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89848
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3074_7069",
    result: "effect2_innerShadow_3074_7069"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "6.3208580017089844 6.3208580017089844",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_3074_7069",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 190, 0, 0.2)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_3074_7069"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_innerShadow_3074_7069"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_in_3074_7069",
    x: 45.5977,
    y: 69.5391,
    width: 78.0547,
    height: 26.6289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.316413
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.688198
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3074_7069"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "6.3208580017089844 6.3208580017089844",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_innerShadow_3074_7069",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(179, 40, 33, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_3074_7069"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_innerShadow_3074_7069"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3074_7069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1881 47.4852) rotate(-62.168) scale(111.251 11.9471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3074_7069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.516 98.2402) rotate(-63.469) scale(110.62 11.7311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3074_7069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.26 115.035) rotate(-65.0074) scale(96.3119 10.0729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3074_7069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.503 62.3295) rotate(-63.3892) scale(145.606 15.4669)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3074_7069",
    x1: 122.252,
    y1: 112.222,
    x2: 132.834,
    y2: 120.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3074_7069",
    x1: 110.598,
    y1: 89.5201,
    x2: 113.437,
    y2: 89.5201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3074_7069",
    x1: 101.434,
    y1: 112.234,
    x2: 102.796,
    y2: 112.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3074_7069",
    x1: 119.164,
    y1: 75.4066,
    x2: 120.094,
    y2: 75.4066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3074_7069",
    x1: 120.992,
    y1: 69.3336,
    x2: 122.281,
    y2: 69.3336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3074_7069",
    x1: 106.137,
    y1: 100.265,
    x2: 107.441,
    y2: 100.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3074_7069",
    x1: 115.914,
    y1: 82.0285,
    x2: 117.205,
    y2: 82.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3074_7069",
    x1: 125.051,
    y1: 60.3449,
    x2: 126.941,
    y2: 60.3449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3074_7069",
    x1: 61.3166,
    y1: 93.3233,
    x2: 87.6827,
    y2: 93.3233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3074_7069",
    x1: 89.578,
    y1: 62.3107,
    x2: 90.3736,
    y2: 62.3107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3074_7069",
    x1: 80.383,
    y1: 148.419,
    x2: 87.9662,
    y2: 148.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3074_7069",
    x1: 112.926,
    y1: 163.064,
    x2: 113.926,
    y2: 163.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3074_7069",
    x1: 127.184,
    y1: 143.303,
    x2: 128.033,
    y2: 143.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3074_7069",
    x1: 74.4374,
    y1: 160.478,
    x2: 77.571,
    y2: 160.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3074_7069",
    x1: 139.208,
    y1: 88.74,
    x2: 159.835,
    y2: 88.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3074_7069",
    x1: 135.621,
    y1: 122.68,
    x2: 138.075,
    y2: 122.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3074_7069",
    x1: 130.211,
    y1: 133.382,
    x2: 133.799,
    y2: 133.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3074_7069",
    x1: 70.6173,
    y1: 168.622,
    x2: 71.228,
    y2: 168.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3074_7069",
    x1: 30.9025,
    y1: 166.163,
    x2: 37.3208,
    y2: 166.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3074_7069",
    x1: 54.9765,
    y1: 127.287,
    x2: 57.4007,
    y2: 127.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3074_7069",
    x1: 41.5234,
    y1: 151.95,
    x2: 42.776,
    y2: 151.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3074_7069",
    x1: 47.8167,
    y1: 139.503,
    x2: 50.347,
    y2: 139.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3074_7069",
    x1: 6.98053,
    y1: 124.94,
    x2: 18.6995,
    y2: 124.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3074_7069",
    x1: 42.5978,
    y1: 76.0411,
    x2: 44.0785,
    y2: 76.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3074_7069",
    x1: 94.8279,
    y1: 125.373,
    x2: 98.8979,
    y2: 125.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3074_7069",
    x1: 22.6839,
    y1: 103.726,
    x2: 32.3777,
    y2: 103.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3074_7069",
    x1: 118.023,
    y1: 152.057,
    x2: 124.776,
    y2: 152.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3074_7069",
    x1: 90.379,
    y1: 135.665,
    x2: 91.4554,
    y2: 135.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3074_7069",
    x1: 128.715,
    y1: 34.9721,
    x2: 145.808,
    y2: 34.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3074_7069",
    x1: 102.269,
    y1: -3.16408,
    x2: 139.327,
    y2: -3.16408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3074_7069",
    x1: 33.6956,
    y1: 88.2409,
    x2: 38.9112,
    y2: 88.2409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3074_7069",
    x1: 57.91,
    y1: 42.009,
    x2: 63.8815,
    y2: 42.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3074_7069",
    x1: 48.3126,
    y1: 60.9063,
    x2: 54.9002,
    y2: 60.9063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3074_7069",
    x1: 93.7969,
    y1: 49.9171,
    x2: 98.9321,
    y2: 49.9171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3074_7069",
    x1: 68.676,
    y1: 12.5352,
    x2: 81.3497,
    y2: 12.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3074_7069",
    x1: 72.9606,
    y1: 175.919,
    x2: 110.271,
    y2: -49.4357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_3074_7069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.9878 68.0257) scale(92.5941 101.583)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3074_7069",
    x1: 70.8609,
    y1: 140.285,
    x2: 90.5203,
    y2: 5.5403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3074_7069",
    x1: 39.7603,
    y1: 134.679,
    x2: 59.4202,
    y2: -0.0688752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3074_7069",
    x1: 141.318,
    y1: 152.374,
    x2: 160.921,
    y2: 18.0118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3074_7069",
    x1: 119.065,
    y1: 149.309,
    x2: 138.755,
    y2: 14.3605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3074_7069",
    x1: 97.6273,
    y1: 145.283,
    x2: 117.294,
    y2: 10.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3074_7069",
    x1: 92.5278,
    y1: 89.9858,
    x2: 119.61,
    y2: 102.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.515183,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3074_7069",
    x1: 41.3834,
    y1: 44.6527,
    x2: 52.3592,
    y2: 51.7612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3074_7069",
    x1: 68.8742,
    y1: 59.9224,
    x2: 87.7741,
    y2: 72.0119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3074_7069",
    x1: 121.979,
    y1: 18.2111,
    x2: 50.7189,
    y2: 149.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129808,
    stopColor: "#E39934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513763,
    stopColor: "#FFF3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966346,
    stopColor: "#EEBB4C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3074_7069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 170.196,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPantherBetScratch);
export default __webpack_public_path__ + "static/media/panther-bet-scratch.65c7817c547f678d2adf6cd6acffb544.svg";
export { ForwardRef as ReactComponent };